// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Vp12","rightAdornment":"Header_rightAdornment__KH1Kb"};